var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"my-calendar-modal__link",attrs:{"to":{
    name: 'FormPage',
    params: {
      form_name: _vm.form_name,
      backToPath: _vm.$route.path,
    },
  },"replace":""}},[_c('div',{staticClass:"my-calendar-modal__link__left"},[_c('p',{staticClass:"small-medium"},[_vm._v(_vm._s(_vm.title))])]),_c('svg',{class:'my-calendar-modal__link__right-svg',attrs:{"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none","xmlns":"http://www.w3.org/2000/svg","svg-inline":'',"role":'presentation',"focusable":'false',"tabindex":'-1'}},[_c('path',{attrs:{"opacity":".2","d":"M1 11l5-5-5-5","stroke":"#111114","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }